import { Routes } from '@angular/router';
import { ZiroSearchComponent } from '../../../../components/src/lib/helpdesk/search/search.component';
import { routeGuardFn } from '../../../../components/src/lib/shared/services/route-guard.service';
import { ziroFormConfirmRouteChangeGuardFn } from '../../../../components/src/lib/forms/ziro-form-confirm-route-change.service';
import { Microsoft360DetailComponent } from '../../../../components/src/lib/helpdesk/microsoft/microsoft360-view/microsoft360-detail/microsoft360-detail.component';
import { Microsoft360DetailHomeComponent } from '../../../../components/src/lib/helpdesk/microsoft/microsoft360-view/microsoft360-detail-home/microsoft360-detail-home.component';
import { MicrosoftViewLicensesComponent } from '../../../../components/src/lib/helpdesk/microsoft/microsoft-view-licenses/microsoft-view-licenses.component';
import { TeamsAudioConferencingComponent } from '../../../../components/src/lib/helpdesk/microsoft/teams-audio-conferencing/teams-audio-conferencing.component';
import { TeamsCallingContainerComponent } from '../../../../components/src/lib/helpdesk/microsoft/teams-calling-container/teams-calling-container.component';
import { ZiroMicrosoftTeamsCallingDialPlanSelectorFormComponent } from '../../../../components/src/lib/helpdesk/microsoft/teams-calling-container/teams-calling/microsoft-teams-calling-dial-plan-selector-form/microsoft-teams-calling-dial-plan-selector-form.component';
import { SecurityGroupMembershipsComponent } from '../../../../components/src/lib/helpdesk/microsoft/security-group-memberships/security-group-memberships.component';
import { DubberComplianceRecordingComponent } from '../../../../components/src/lib/helpdesk/microsoft/dubber-compliance-recording/dubber-compliance-recording.component';
import { SharedVoicemailGroupsMembershipsComponent } from '../../../../components/src/lib/helpdesk/microsoft/shared-voicemail-groups-memberships/shared-voicemail-groups-memberships.component';
import { TeamsCallQueueEditComponent } from '../../../../components/src/lib/teams-call-queues/teams-call-queue/teams-call-queue-edit.component';
import { TeamsAutoAttendantEditComponent } from '../../../../components/src/lib/teams-auto-attendants/teams-auto-attendant-edit-form/teams-auto-attendant-edit.component';
import { Microsoft360CallQueueComponent } from '../../../../components/src/lib/helpdesk/microsoft/microsoft360-view/microsoft360-call-queue/microsoft360-call-queue.component';

export const zpmHelpdeskRoutes: Routes = [
  {
    path: 'helpdesk',
    children: [
      {
        path: 'tenants/:tenantId',
        children: [
          {
            path: 'search',
            component: ZiroSearchComponent,
            canActivate: [routeGuardFn],
            canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
          },
          {
            path: '360-view/:upn',
            component: Microsoft360DetailComponent,
            canActivate: [routeGuardFn],
            children: [
              {
                path: '',
                component: Microsoft360DetailHomeComponent,
                data: {
                  title: 'tkey;microsoft_360.view.page.title',
                  breadcrumb: 'tkey;microsoft_360.view.breadcrumb.home.text',
                },
              },
              {
                path: 'licenses',
                component: MicrosoftViewLicensesComponent,
                canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
                data: {
                  title: 'tkey;microsoft_360.view.licenses.info.title',
                  breadcrumb: 'tkey;microsoft_360.view.licenses.info.breadcrumb.text',
                },
              },
              {
                path: 'audio-conference',
                component: TeamsAudioConferencingComponent,
                canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
                data: {
                  title: 'tkey;microsoft_360.view.teams.audio.conference.title',
                  breadcrumb: 'tkey;microsoft_360.view.teams.audio.conference.breadcrumb.text',
                },
              },
              {
                path: 'teams-calling',
                component: TeamsCallingContainerComponent,
                data: {
                  title: 'tkey;microsoft_360.view.teams.calling.title',
                  breadcrumb: 'tkey;microsoft_360.view.teams.calling.title',
                },
                children: [
                  {
                    path: '',
                    component: ZiroMicrosoftTeamsCallingDialPlanSelectorFormComponent,
                    canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
                  },
                ],
              },
              {
                path: 'security-group-membership',
                component: SecurityGroupMembershipsComponent,
                canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
                data: {
                  title: 'tkey;microsoft_360.view.security.groups.tile.title',
                  breadcrumb: 'tkey;microsoft_360.view.security.groups.membership.breadcrumb.text',
                },
              },
              {
                path: 'dubber-compliance-recording',
                component: DubberComplianceRecordingComponent,
                canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
                data: {
                  title: 'tkey;microsoft_360.view.dubber.tile.title',
                  breadcrumb: 'tkey;microsoft_360.view.dubber.breadcrumb.text',
                },
              },
              {
                path: 'shared-voicemail-groups',
                component: SharedVoicemailGroupsMembershipsComponent,
                canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
                data: {
                  title: 'tkey;microsoft_360.view.shared_voicemail_groups.tile.title',
                  breadcrumb: 'tkey;microsoft_360.view.shared_voicemail_groups.breadcrumb.text',
                },
              },
              {
                path: 'teams-call-queue',
                component: Microsoft360CallQueueComponent,
                children: [
                  {
                    path: 'new',
                    component: TeamsCallQueueEditComponent,
                    canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
                    data: {
                      title: 'tkey;microsoft_360.call_queues.tile.title',
                      breadcrumb: 'tkey;microsoft_360.view.call_queues.breadcrumb.text',
                      is360ViewChild: true,
                    },
                  },
                  {
                    path: ':callQueueId',
                    component: TeamsCallQueueEditComponent,
                    canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
                    data: {
                      title: 'tkey;microsoft_360.call_queues.tile.title',
                      breadcrumb: 'tkey;microsoft_360.view.call_queues.breadcrumb.text',
                      is360ViewChild: true,
                    },
                  },
                ],
              },
              {
                path: 'teams-auto-attendant/new',
                component: TeamsAutoAttendantEditComponent,
                canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
                data: {
                  title: 'tkey;microsoft_360.auto_attendants.tile.title',
                  breadcrumb: 'tkey;microsoft_360.view.auto_attendants.breadcrumb.text',
                  is360ViewChild: true,
                },
              },
              {
                path: 'teams-auto-attendant/:autoAttendantId',
                component: TeamsAutoAttendantEditComponent,
                canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
                data: {
                  title: 'tkey;microsoft_360.auto_attendants.tile.title',
                  breadcrumb: 'tkey;microsoft_360.view.auto_attendants.breadcrumb.text',
                  is360ViewChild: true,
                },
              },
            ],
          },
        ],
      },
    ],
  },
];
